export default "__VITE_ASSET__LajK6$Wx__"